export default {
  en: {
    'components.registrations.filing-types-list.type': 'Type',
    'components.registrations.filing-types-list.registration-type': 'Registration Type',
    'components.registrations.filing-types-list.submission-period': 'Submission Period',
    'components.registrations.filing-types-list.day-due': 'Day Due',
    'components.registrations.filing-types-list.periodicity': 'Periodicity',
    'components.registrations.filing-types-list.experience': 'Experience',
    'components.registrations.filing-types-list.filing-start-date': 'Filing Start Date',
  },
};
